window.HelpMeChooseQuestionData = [
  {
    id: 'choose-1',
    question: '1.Quel type de piscine avez-vous?',
    multiSelect: false,
    options: [
      {
        id: 'q1-A',
        text: 'Piscine enterrée',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose1-A.png',
        width: 404,
        height: 300,
        alt: 'Piscine enterrée',
      },
      {
        id: 'q1-B',
        text: 'Piscine hors-sol',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose1-B.png',
        width: 404,
        height: 300,
        alt: 'Piscine hors-sol',
      },
      {
        id: 'q1-C',
        text: 'Je ne sais pas',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose4-D.png',
        width: 820,
        height: 72,
        alt: 'Je ne sais pas',
        extraClass: 'not-sure',
      },
    ],
  },
  {
    id: 'choose-2',
    question: '2.Quelle description correspond le mieux à la configuration de votre piscine ?(Plusieurs réponses possibles)',
    multiSelect: true,
    options: [
      {
        id: 'q2-A',
        text: 'Plutôt régulière et rectangulaire',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-A.png',
        width: 404,
        height: 143,
        alt: 'Plutôt régulière et rectangulaire',
      },
      {
        id: 'q2-B',
        text: 'Forme arrondie ou libre',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-B.png',
        width: 404,
        height: 143,
        alt: 'Forme arrondie ou libre',
      },
      {
        id: 'q2-C',
        text: 'Avec pentes, zones profondes ou transitions irrégulières',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-C.png',
        width: 404,
        height: 143,
        alt: 'Avec pentes, zones profondes ou transitions irrégulières',
      },
      {
        id: 'q2-D',
        text: 'Avec marches, rebords ou plage immergée peu profonde',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-D.png',
        width: 404,
        height: 143,
        alt: 'Avec marches, rebords ou plage immergée peu profonde',
      },
      {
        id: 'q2-E',
        text: 'Je ne sais pas',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose4-D.png',
        width: 820,
        height: 72,
        alt: 'Je ne sais pas',
        extraClass: 'not-sure',
      },
    ],
  },
  {
    id: 'choose-3',
    question: '3.Quelle est la taille de votre piscine?',
    multiSelect: false,
    options: [
      {
        id: 'q3-A',
        text: 'Petite piscine, jusqu’à 6 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-A.png',
        width: 404,
        height: 186,
        alt: 'Small pool',
      },
      {
        id: 'q3-B',
        text: 'Piscine moyenne, jusqu’à 10 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-B.png',
        width: 404,
        height: 186,
        alt: 'Medium pool',
      },
      {
        id: 'q3-C',
        text: 'Grande piscine, plus de 10 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-C.png',
        width: 404,
        height: 186,
        alt: 'Large pool',
      },
      {
        id: 'q3-D',
        text: "Je ne suis pas sûr(e)",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-D.png',
        width: 404,
        height: 186,
        alt: 'Not sure',
      },
    ],
  },
  {
    id: 'choose-4',
    question: '4.Quel est votre plus grand défi en matière de nettoyage ?',
    multiSelect: false,
    options: [
      {
        id: 'q4-A',
        text: 'Débris légers',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_A.png',
        width: 404,
        height: 186,
        alt: 'Complete cleaning coverage',
      },
      {
        id: 'q4-B',
        text: 'Feuilles abondantes, sable, algues ou fines particules',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_B.png',
        width: 404,
        height: 186,
        alt: 'Easy maintenance',
      },
      {
        id: 'q4-C',
        text: "Zones difficiles à atteindre",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_C.png',
        width: 404,
        height: 186,
        alt: 'Value for money',
      },
      {
        id: 'q4-D',
        text: "Je ne suis pas sûr(e)",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_D.png',
        width: 404,
        height: 186,
        alt: 'Not sure',
      },
    ],
  },
  {
    id: 'choose-5',
    question: '5.Quelle phrase vous correspond le mieux ?',
    multiSelect: false,
    options: [
      {
        id: 'q5-A',
        text: 'Je veux une automatisation complète du nettoyage',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_A.png',
        width: 404,
        height: 186,
        alt: 'Affordable option',
      },
      {
        id: 'q5-B',
        text: 'Je veux les meilleures performances de nettoyage',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_C.png',
        width: 404,
        height: 186,
        alt: 'Balanced option',
      },
      {
        id: 'q5-C',
        text: 'Je veux l’expérience de nettoyage la plus avancée',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_B.png',
        width: 404,
        height: 186,
        alt: 'Strong performance',
      },
      {
        id: 'q5-D',
        text: 'Je veux l’entretien quotidien le plus simple',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/5D.png',
        width: 404,
        height: 186,
        alt: 'Top model',
      },
    ],
  },
];
